<script setup>
import {articleMiddleHeading} from '~/utils/article-middle-ad.mjs';
const props=defineProps({body:Object,articleId:[String,Number],enabled:{type:Boolean,default:true}});
const settings=useState('settings');
const mobile=ref(false),host=shallowRef(null);
let media;
const targetId=computed(()=>'yandex_rtb_R-A-20123375-7-article-'+props.articleId);
function place(){
  const heading=articleMiddleHeading(props.body?.children,props.articleId);
  if(host.value?.parentNode===props.body && host.value?.nextSibling===heading)return;
  host.value?.remove();host.value=null;
  if(!heading)return;
  const node=document.createElement('div');
  node.className='uo-article-middle-host';
  props.body.insertBefore(node,heading);
  host.value=node;
}
function updateMobile(){mobile.value=media.matches}
onMounted(()=>{
  media=window.matchMedia('(max-width: 767px)');
  updateMobile();media.addEventListener('change',updateMobile);place();
});
watch(()=>[props.body,props.articleId],place,{flush:'post'});
onBeforeUnmount(()=>{media?.removeEventListener('change',updateMobile);host.value?.remove()});
</script>
<template>
 <Teleport v-if="mobile && host && enabled && !settings?.disableAdvertising" :to="host">
  <section class="uo-article-middle-ad" aria-label="Реклама" data-ad-placement="article-middle-mobile">
   <AdContainer :id="targetId" block-id="R-A-20123375-7" :max-height="300" />
  </section>
 </Teleport>
</template>
<style scoped>
:global(.uo-article-middle-host:empty){display:none}
.uo-article-middle-ad{width:100%;min-width:0;height:300px;max-height:300px;margin-block:24px;white-space:normal;line-height:normal}
.uo-article-middle-ad :deep(.w-full){height:300px;max-height:300px;width:100%;min-width:0}
</style>
